module.exports = __webpack_public_path__ + "static/dima_testimonial-1468162cd1f5647001b612deaf6c711f.jpg";